import React from 'react';
import PropTypes from 'prop-types';

export const DraftTrackerMobileTable = ({ rows, seasonToShow }) => {
    return (
        <div>
            <div className="draft-tracker-embeddable-table-mobile">
                <div className="draft-tracker-embeddable-table-mobile__body">
                    {rows.map((row, i) => (
                        <div
                            key={i}
                            className={
                                'draft-tracker-embeddable-table-mobile__row'
                            }
                        >
                            <div className="draft-tracker-embeddable-table-mobile__cell draft-tracker-embeddable-table-mobile__cell-pick">
                                {row.pickNumber}
                            </div>
                            <div className="draft-tracker-embeddable-table-mobile__cell draft-tracker-embeddable-table-mobile__cell-player-image-cell">
                                {row.photoUrl ? (
                                    <div
                                        style={{
                                            backgroundImage: `url(${row.photoUrl}?im=Scale,width=0.2,height=0.2)`
                                        }}
                                        className="draft-tracker-embeddable-table-mobile__cell-player__image"
                                    />
                                ) : (
                                    <div
                                        className={
                                            'draft-tracker-embeddable-table-mobile__cell-player__image-placeholder'
                                        }
                                    />
                                )}
                            </div>
                            <div className="draft-tracker-embeddable-table-mobile__cell draft-tracker-embeddable-table-mobile__cell-player">
                                <a
                                    href={PULSE.app.common.url.getProspectProfileURL(
                                        row.playerId,
                                        seasonToShow
                                    )}
                                    className="draft-tracker-embeddable-table-mobile__cell-details-link"
                                >
                                    <div className="draft-tracker-embeddable-table-mobile__cell-details">
                                        <span className="draft-tracker-embeddable-table-mobile__cell-player__name">
                                            <span className="draft-tracker-embeddable-table-mobile__cell-player__name-text">
                                                {row.fullName}
                                            </span>
                                        </span>
                                    </div>
                                </a>
                                <div className="draft-tracker-embeddable-table-mobile__cell-total__from-text-wrapper">
                                    <div className="draft-tracker-embeddable-table-mobile__cell-total__from-text">
                                        <span className="draft-tracker-embeddable-table-mobile__cell-total__from-text-from-label">
                                            From:
                                        </span>{' '}
                                        {row.juniorClub ?? ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

DraftTrackerMobileTable.propTypes = {
    rows: PropTypes.array.isRequired,
    seasonToShow: PropTypes.string.isRequired
};
